module.exports = {
  title: 'Lorem ipsum Long Title',
  shortName: 'Lorem ipsum',
  description: 'Lorem ipsum',
  siteUrl: `https://assassinscreed.com/quiz/`,
  cdnUrl: 'https://ubi-static-website-hosting-prod.ubisoft.com/ayzenberg/prod',
  startUrl: '/',
  pathPrefix: '/game/assassins-creed/quiz',
  sitePath: '/game/assassins-creed/quiz',
  backgroundColor: '#000000',
  themeColor: '#000000',
  display: 'minimal-ui',
  icon: 'src/images/ac-color-favicon.png',
}
